// src/contexts/index.js
// Unified exports - switches between AWS and Supabase based on environment

export { useAuth } from './SharedAuthContext';
export { AuthProvider as AWSAuthProvider } from './AuthContextAWS';
export { DemoTourProvider, useDemoTour } from './DemoTourContext';

// Helper to get the right provider
const useAWS = (process.env.REACT_APP_USE_AWS || '').trim() === 'true';
export const AuthProvider = useAWS
  ? require('./AuthContextAWS').AuthProvider
  : require('./AuthContext').AuthProvider;
